import { RunListPage } from '@/features/calibration-runs';

export function CalibrationPage() {
  return <RunListPage />;
}
